module.exports = __webpack_public_path__ + "Flag-90.9f76cf02c2856ec251e92d4bbec082ae.svg";